import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FieldService } from '../../../../../../common/services/Field.service';
import * as _ from 'lodash';
import { PropertiesConst, DefaultField } from './properties.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { FieldType } from '../../contact/properties/properties.const';
import { GroupService } from 'app/common/services/Group.service';
import { Observable } from 'rxjs';
import { UserService } from 'app/common/services/User.service';
import { OrganizeService } from 'app/common/services/Organize.service';

declare var $: any;

@Component({
  selector: 'settings-tickets-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.css'],
  providers: [FieldService, GroupService, UserService, OrganizeService],
})
@Injectable()
export class PropertiesComponent extends BaseListComponent {
  @ViewChild('template') template: ElementRef;
  public modelFilter: any = {};
  public types: any = [];
  public data_options = [];
  public allGroups: any = [];
  public allAgent: any = [];
  public allOrganize: any = [];

  constructor(
    private organizeService: OrganizeService,
    private userService: UserService,
    private groupService: GroupService,
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private fieldService: FieldService
  ) {
    super(changeDetector, toastr, modalService);
    this.types = [{ id: '', text: 'Kiểu dữ liệu' }, ...PropertiesConst.PropertiesArray()];
    this.displayColumns = PropertiesConst.displayColumns();
  }

  async ngOnInit() {
    this.loadGroups(), this.getAllAgent(), this.getOrganize(), this.loadData({ target: 'ticket' });
  }

  setMessage(message: any) {
    this.message = message;
    setTimeout(() => {
      this.message = null;
    }, 3000);
    return;
  }

  async loadData(request: any = {}, sort: any = {}) {
    this.data = [];
    request.target = 'ticket';
    const payload = await this.buildBasePayload(request, sort);
    this.fieldService
      .list(payload)
      .toPromise()
      .then(
        res => {
          if (res.status == 200 && res.error == false) {
            this.data = res.data.list;
            this.data = this.data.map(res => {
              res.display_type = PropertiesConst.displayTypeColumn(res.type);
              return res;
            });
            this.initPage(res.data.total);
          } else {
            this.throwError();
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ title: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }

  loadGroups() {
    this.groupService
      .allGroup({ target: 'user' })
      .toPromise()
      .then(res => {
        const roomList = [{ id: '-1', text: '--Chọn--' }];
        res.data.forEach((c: any) => {
          roomList.push({
            text: c.name,
            id: c.id.toString(),
          });
        });
        this.allGroups = roomList;
      });
  }

  getAllAgent() {
    this.userService
      .all({})
      .toPromise()
      .then(res => {
        const agentList = [];
        res.data.list.forEach((c: any) => {
          agentList.push({
            text: c.name,
            id: c._id,
          });
        });
        this.allAgent = agentList;
      });
  }

  getOrganize() {
    this.organizeService.allOrganize().subscribe(res => {
      if (res.status == 200 && res.error == false) {
        const organizeList = [
          {
            id: '-1',
            text: '--Chọn--',
          },
        ];
        res.data.forEach((c: any) => {
          organizeList.push({
            text: c.name,
            // id: c.id, // lấy dữ liệu từ mysql
            id: c.organize_id, // lấy dữ liệu từ mongo
          });
        });
        this.allOrganize = organizeList;
      }
    });
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới thuộc tính ticket' : 'Cập nhật thuộc tính ticket',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'title',
        label: 'Tiêu đề thuộc tính',
        type: FormFieldType.Text,
        value: this.model.title,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'key',
        label: 'Key thuộc tính',
        type: FormFieldType.Text,
        value: this.model.key,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: '_note',
        label: '',
        type: FormFieldType.Note,
        value: `<span class="mb-2 text-muted text-sm mt-1">Các key thuộc tính không được trùng với các key thuộc tính mặc định: ${DefaultField.join(', ')}</span>`,
        width: 'full',
        order: 2,
      },
      {
        key: 'type',
        label: 'Kiểu dữ liệu',
        type: FormFieldType.Select2,
        value: this.model.type,
        required: true,
        disabled: false,
        width: 'full',
        order: 3,
        options: {
          data: this.types,
          select2Options: {
            placeholder: { id: '', text: 'Kiểu dữ liệu' },
          },
        },
      },
    ];
    let order = 4;
    if (this.model.type == FieldType.Select || this.model.type == FieldType.MultiSelect) {
      this.modelDisplay.push({
        key: 'label_option',
        label: 'Giá trị lựa chọn',
        value: '',
        width: 'full',
        order: order,
      });
      order++;
      for (let i = 1; i <= this.data_options.length; i++) {
        this.modelDisplay.push({
          key: 'data_option_' + i,
          label: 'Lựa chọn ' + i,
          type: FormFieldType.Text,
          value: this.model['data_option_' + i],
          required: true,
          disabled: false,
          remove: true,
          width: 'full',
          order: order,
          options: {
            checkInline: true,
          },
        });
        order++;
      }
      this.modelDisplay.push({
        key: 'btn_option',
        width: 'full',
        type: FormFieldType.CustomButton,
        order: order,
        options: {
          buttons: [
            {
              title: 'Thêm lựa chọn',
              width: '1/4',
              classes: 'btn btn-primary',
              value: 1,
            },
          ],
        },
      });
      order++;
    }
    this.modelDisplay.push({
      key: 'required',
      label: 'Bắt buộc',
      type: FormFieldType.Switch,
      value: this.model.required,
      required: false,
      disabled: false,
      width: 'full',
      order: order + 3,
      options: {
        checkInline: true,
      },
    });

    this.modelDisplay.push({
      key: 'isTempatePermission',
      label: 'Phân quyền',
      type: FormFieldType.Switch,
      value: this.model.isTempatePermission,
      required: false,
      disabled: false,
      width: 'full',
      order: order + 4,
      options: {
        checkInline: true,
      },
    });

    if (this.model.isTempatePermission) {
      const OptionTemplatePermission = [
        {
          key: 'group_id',
          label: 'Bộ phận',
          type: FormFieldType.Select2,
          value: this.model.group_id,
          required: false,
          disabled: false,
          width: 'full',
          order: 3,
          options: {
            data: [{ id: 0, text: '--Chọn--' }, ...this.allGroups],
            select2Options: {
              placeholder: { id: '-1', text: '--Chọn--' },
            },
          },
        },
        {
          key: 'agents',
          label: 'Chuyên viên',
          type: FormFieldType.Select2,
          value: this.model.agents,
          required: false,
          disabled: false,
          width: 'full',
          order: 4,
          options: {
            data: this.allAgent,
            select2Options: {
              placeholder: { id: '', text: 'Chuyên viên' },
              multiple: true,
            },
          },
        },
        {
          key: 'organization_id',
          label: 'Tổ chức',
          type: FormFieldType.Select2,
          value: this.model.organization_id,
          required: false,
          disabled: false,
          width: 'full',
          order: 5,
          options: {
            data: [{ id: 0, text: '--Chọn--' }, ...this.allOrganize],
            select2Options: {
              placeholder: { id: '-1', text: '--Chọn--' },
            },
          },
        },
        {
          key: 'permission',
          label: 'Quyền',
          type: FormFieldType.Select2,
          value: this.model.permission || null,
          required: true,
          disabled: false,
          width: 'full',
          order: 6,
          options: {
            data: [
              { id: '0', text: 'Ẩn' },
              { id: '1', text: 'Đọc' },
              { id: '2', text: 'Chỉnh sửa' },
            ],
            select2Options: {
              placeholder: { id: '-1', text: 'Quyền' },
            },
          },
        },
      ];
      OptionTemplatePermission.map((value: any, index: any) => {
        this.modelDisplay.push(value);
      });
    }
  }

  async deleteOption(key) {
    this.model[key] = null;
    this.data_options = this.data_options.filter(i => i !== key);
    console.log(this.model);
    console.log(this.data_options);
    await this.setUpModel();
  }

  async addOption() {
    const i = this.data_options.length + 1;
    this.data_options.push('data_option_' + i);
  }

  async edit(id, payload) {
    this.fieldService.update(id, payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
          this.closeModal();
        } else {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: res.message,
          });
        }
      },
      error => {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: error.message,
        });
      }
    );
  }

  async add(payload) {
    this.fieldService.create(payload).subscribe(
      res => {
        if (res.status === 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: res.message,
          });
        }
      },
      error => {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: error.message,
        });
      }
    );
  }

  async openConfirmDelete() {
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDelete();
    }
  }

  async submitDelete() {
    this.fieldService._delete(this.delete_id).subscribe(
      res => {
        if (res.status == 200 && res.error == false) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        this.typeModal = 'add';
        await this.setUpModel();
        this.openModal(this.template, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        Object.keys(item).forEach(key => {
          if (item[key] !== null && item[key] !== undefined) {
            this.model[key] = item[key];
            if (key === 'data') {
              this.data_options = [];
              for (let i = 1; i <= item[key].length; i++) {
                this.data_options.push('data_option_' + i);
                this.model['data_option_' + i] = item[key][i - 1];
              }
            }
          }
        });

        if (this.model.permission_detail) {
          this.model.isTempatePermission = this.model.permission_detail.status;
          Object.keys(this.model.permission_detail).forEach(key => {
            if (!this.model[key]) {
              this.model[key] = this.model.permission_detail[key];
            }
          });
        }
        this.typeModal = 'edit';
        await this.setUpModel();
        this.openModal(this.template, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.delete:
        this.delete_id = item._id;
        await this.openConfirmDelete();
        break;
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    switch (key) {
      case 'type':
        if (item[key] !== FieldType.Select || item[key] !== FieldType.MultiSelect) {
          this.data_options = ['data_option_1'];
        }
        break;
      case 'btn_option':
        await this.addOption();
        break;
      case 'key':
        if (DefaultField.includes(item[key])) {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: 'Key thuộc tính trùng với các key giá trị mặc định. Vui lòng chọn key thuộc tính khác!',
          });
        } else if (!/^[A-Za-z_]+$/gi.test(item[key])) {
          return this.setMessage({
            class: 'alert dark alert-danger',
            content: "Key thuộc tính chỉ bao gồm chữ cái và dấu '_' !",
          });
        } else {
          this.message = null;
        }
        break;
      default:
        break;
    }
    await this.setUpModel();
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    const payload = {
      target: 'ticket',
      key: this.model.key ? this.model.key.trim().toLowerCase() : '',
      title: this.model.title ? this.model.title.trim() : '',
      type: this.model.type,
      required: this.model.required,
    };

    const data = [];
    Object.keys(this.model).forEach(key => {
      if (key.includes('data_option') && this.data_options.includes(key)) {
        data.push(this.model[key]);
      }
    });
    if (this.model.type === FieldType.Select || this.model.type === FieldType.MultiSelect) {
      console.log(data, 'data');

      // Lọc các phần tử bị trùng
      const duplicateArray = data.map(e => e.trim()).filter((value, index, self) => self.indexOf(value) !== index);
      if (duplicateArray && duplicateArray.length > 0) {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: `Các giá trị trùng lặp: ${duplicateArray.join(', ')}`,
        });
      }
      payload['data'] = data;
    }

    if (this.model.organization_id == '0') {
      this.model.organization_id = null;
    }

    if (this.model.group_id == '0') {
      this.model.group_id = null;
    }

    if (this.model.isTempatePermission) {
      if (!this.model.organization_id && !this.model.group_id && !this.model.agents) {
        return this.setMessage({
          class: 'alert dark alert-danger',
          content: 'Chọn 1 trong 3 đối tượng',
        });
      }
    }

    let payloadTemplatePermission = {
      isTempatePermission: this.model.isTempatePermission,
      group_id: this.model.group_id,
      agents: this.model.agents,
      organization_id: this.model.organization_id,
      permission: this.model.permission,
    };

    const payloadTotal = {
      payloadFields: payload,
      payloadTemplatePermission: payloadTemplatePermission,
    };
    if (this.typeModal === 'add') {
      await this.add(payloadTotal);
    } else if (this.typeModal === 'edit') {
      await this.edit(this.model._id, payloadTotal);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/tickets/properties/properties.component.ts